import Layout from "ui/components/Layout/index";
import { Outlet } from "react-router-dom";
export default function Auth() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
